<template>
	<div class="detail-wrap">
		<el-form ref="editForm" :model="tenant">
			<div class="d-header clearfix">
				<div class="fl">
					<i class="el-icon-info" />
					{{ dataId ? '查看' : '新增' }}厂商
				</div>
				<div class="fr">
					<el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button>
					<el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
				</div>
			</div>
			<div class="d-cont edit-mce-box">
				<div class="d-item">
					<div class="title first"><b>基本信息</b></div>
					<table class="table-detail">
						<tbody>
							<tr>
								<th>
									<em class="f-red">*</em>
									厂商名称
								</th>
								<td>
                  <el-input type="text" autocomplete="off" v-model="tenant.name" clearable />
								</td>
								<th>
									<em class="f-red">*</em>
                  用户手机
								</th>
								<td>
                  <el-input type="text" autocomplete="off" v-model="tenant.name" clearable />
								</td>
								<th>状态</th>
								<td>
                  <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="tenant.status" >
                      <el-option  label="正常" :value="0" />
                      <el-option  label="禁用" :value="1" />
                    </el-select>
                  </el-form-item>
                </td>
                <th>厂商简称</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="tenant.name" clearable />
                </td>
							</tr>
							<tr>
								<th>备注</th>
								<td colspan="4">
									<el-input type="textarea" :rows="2" placeholder="请输入内容" size="small" v-model="tenant.faultDescription" clearable></el-input>
								</td>
							</tr>
							<tr>
								<th>创建人</th>
								<td>{{ tenant.createBy }}</td>
								<th>创建时间</th>
								<td>{{ tenant.createDate }}</td>
								<th>更新人</th>
								<td>{{ tenant.modifyBy }}</td>
								<th>更新时间</th>
								<td>{{ tenant.modifyDate }}</td>
							</tr>
						</tbody>
					</table>
				</div>
        <div class="d-item">
          <div class="title first"><b>关键参数</b></div>
          <table class="table-detail">
            <tbody>
            <tr>
              <th>
                <em class="f-red">*</em>
                厂商名称
              </th>
              <td>
                <el-input type="text" autocomplete="off" v-model="tenant.name" clearable />
              </td>
              <th>
                <em class="f-red">*</em>
                用户手机
              </th>
              <td>
                <el-input type="text" autocomplete="off" v-model="tenant.name" clearable />
              </td>
              <th>状态</th>
              <td>
                <el-form-item >
                  <el-select v-model="tenant.status">
                    <el-option   label="正常" :value="0" />
                    <el-option  label="禁用" :value="1" />
                  </el-select>
                </el-form-item>
              </td>
              <th>厂商简称</th>
              <td>
                <el-input type="text" autocomplete="off" v-model="tenant.name" clearable />
              </td>
            </tr>
            <tr>
              <th>备注</th>
              <td colspan="4">
                <el-input type="textarea" :rows="2" placeholder="请输入内容" size="small" v-model="tenant.faultDescription" clearable></el-input>
              </td>
            </tr>
            <tr>
              <th>创建人</th>
              <td>{{ tenant.createBy }}</td>
              <th>创建时间</th>
              <td>{{ tenant.createDate }}</td>
              <th>更新人</th>
              <td>{{ tenant.modifyBy }}</td>
              <th>更新时间</th>
              <td>{{ tenant.modifyDate }}</td>
            </tr>
            </tbody>
          </table>
        </div>
				<div class="d-item">
					<div class="title"><b>附件信息</b></div>
					<table class="table-detail">
						<tbody>
							<tr>
								<td colspan="8"><baseUpload accept="file" multi="true" :file.sync="tenant.tenantAttachmentDTOs"></baseUpload></td>
							</tr>
						</tbody>
					</table>
				</div>
        <div class="d-item">
          <div class="title">
            <b>运营产品</b>
          </div>
          <div>
          </div>
        </div>
			</div>
		</el-form>
		<productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false" @confirm="confirmCategory" />
	</div>
</template>

<script>
import Tinymce from '@/components/Tinymce';
import request from "../../../router/axios";
export default {
	name: 'tenantEdit',
	props: {
		_dataId: [String, Number]
	},
	components: {
		Tinymce,
	},
	data() {
		return {
			lan: 'zh_CN',
			isEdit: false,
			tabIndex: 'first',
			dataId: '',
			tenant: { status: 0, tenantAttachmentDTOs: [] },
			showProductCategoryDialog: false,
			languageDTOs: []
		};
	},
	computed: {
		enabled: {}
	},
	created() {
		if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			if (this.dataId && !isNaN(this.dataId)) {
				this.isEdit = true;
        request({
          url: '/admin/fwpttenant/get',
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          console.log(response);
          this.tenant = response.data.objx || {};
        })
			} else {
				this.enabled = true;
			}
		},
		saveData() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					this.$baseConfirm('您确定要保存吗？').then(() => {
						var url = HXFW_PREFIX + (this.isEdit ? `/fault/code/update` : `/fault/code/save`);
						this.$http({
							url: url,
							method: `post`,
							data: this.tenant,
							isLoading: true,
							success: res => {
								this.$message({
									message: res.content,
									type: 'success',
									duration: 500,
									onClose: t => {
										if (this.isEdit) {
											this.$baseReload();
										} else {
											this.$baseReload({
												updateParam: {
													_dataId: res.objx
												}
											});
										}
									}
								});
							}
						});
					});
				}
			});
		},
		confirmCategory(rows) {
			if (rows.length > 0) {
				let row = rows[0];
				this.tenant.itemCatId = row.id;
				this.tenant.itemCatName = row.categoryName;
				this.tenant.itemCatCode = row.categoryCode;
			}
		},
	}
};
</script>
